import { noop } from 'lodash'
import React, { createContext, useContext } from 'react'

type TInputContext = {
  onEnter?: () => void
}

const InputContext = createContext<TInputContext>({ onEnter: undefined })

type TInputContextProvider = {
  onEnter?: () => void
  children?: React.ReactNode
}
export const InputContextProvider = (
  props: TInputContextProvider,
): React.ContextType<React.Context<React.ReactElement>> => {
  const { children, onEnter = noop, ...rest } = props
  return (
    <InputContext.Provider value={{ onEnter, ...rest }}>
      {children}
    </InputContext.Provider>
  )
}

export const useInputContext = (): TInputContextProvider =>
  useContext(InputContext)
